import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalModal from './GlobalModal';
import { getModal } from 'store/modal/selectors';
import { teardownModal } from 'store/modal/actions';

const ConnectGlobalModal = () => {
  const dispatch = useDispatch();

  const options = useSelector(getModal);

  const wrappedHandlers = useMemo(
    () => ({
      onClose: () => {
        options.onClose({ actionButtonClicked: false });
        dispatch(teardownModal());
      },

      onButtonClick: () => {
        options.onButtonClick();
        options.onClose({ actionButtonClicked: true });
        dispatch(teardownModal());
      },
    }),
    [dispatch, options],
  );

  return <GlobalModal {...options} {...wrappedHandlers} />;
};

export default ConnectGlobalModal;
